import React, { Component } from 'react';
import momentTZ from 'moment-timezone';

import { Modal } from 'react-bootstrap';

export default class PagamentoDetalhes extends Component {
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	renderMoney(value) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	render() {
		const { props } = this;
		const { pagamento, modalVisible, setModalVisible } = props;

		const statuses = {
			0: 'Processando',
			1: 'Em andamento',
			2: 'Cancelado',
			3: 'Falha',
			4: 'Pendente',
			5: 'Processado',
			6: '',
			7: 'Conflito',
			8: 'Chargeback',
		};

		const tipos = {
			1: 'Débito',
			2: 'Crédito',
			3: 'Dinheiro',
		};

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header closeButton>
					<Modal.Title>
						<h4>Detalhes do Pagamento</h4>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='modal-body'>
						<table className='table'>
							<tbody>
								<tr>
									<td>
										<strong>Cliente: </strong>
									</td>
									<td>
										<span>{pagamento?.uc}</span>
										<br />
										<span>{pagamento?.cliente}</span>
										<br />
										<span>{pagamento?.doc}</span>
									</td>
								</tr>
								<tr>
									<td>
										<strong>Valor total: </strong>
									</td>
									<td>
										<span>{this.renderMoney(pagamento?.total)}</span>
									</td>
								</tr>
								<tr>
									<td>
										<strong>Situação: </strong>
									</td>
									<td>
										<span>{statuses[pagamento?.status]}</span>
									</td>
								</tr>
								<tr>
									<td>
										<strong>Ponto de Venda: </strong>
									</td>
									<td>
										<span>
											{pagamento?.pontoVenda
												? pagamento?.pontoVenda.apelido.toUpperCase()
												: ''}
										</span>
										<br />
										<span>
											{pagamento?.unidade ? pagamento?.unidade.nome : ''}
										</span>
									</td>
								</tr>
								<tr>
									<td>
										<strong>Data Cadastro: </strong>
									</td>
									<td>
										<span>
											{momentTZ.tz(pagamento?.cadastro, 'America/Sao_Paulo').format('DD/MM/YYYY H:mm:ss')}
										</span>
									</td>
								</tr>
								<tr>
									<td>
										<strong>Faturas </strong>
									</td>
									<td>
										{pagamento?.faturas.map((f) => (
											<div className='list-transaction' key={f.id}>
												<span>
													{f.ref}
													{f.fd > 0 ? ' - ' + f.fd : ''}
												</span>
												<br />
												<span>Venc. {f.vencimento}</span>
												<br />
												<span>{this.renderMoney(f.total)}</span>
											</div>
										))}
									</td>
								</tr>
								<tr>
									<td>
										<strong>Transações </strong>
									</td>
									<td>
										{pagamento?.transacoes.map((t) => (
											<div className='list-transaction' key={t.id}>
												<span>{t.atk}</span>
												<br />
												<span>
													{tipos[t.tipo]} ({t.parcelas ? t.parcelas : '1'}x)
												</span>
												<br />
												<span>{t.pan}</span>
												<br />
												<span>{this.renderMoney(t.valor)}</span>
											</div>
										))}
									</td>
								</tr>
								<tr>
									<td>
										<strong>Ajuri</strong>
									</td>
									<td>
										<span>Identificador: {pagamento?.identificador}</span>
										<br />
										<span>Cupom: {pagamento?.cupom}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className='modal-footer'>
						<button
							className='btn btn-default border'
							onClick={() => {
								setModalVisible(false);
							}}>
							Fechar
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		);

	
	}
}
